var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { UsersService } from './users.service';
import { GET_USERS, GET_USERS_STATS, GetUsersSuccessAction, GetUsersFailureAction, GetUsersStatsFailureAction, GetUsersStatsSuccessAction, GET_CURRENT_USER, GetCurrentUserSuccessAction, GetCurrentUserFailureAction } from './users.action';
var UsersEffects = /** @class */ (function () {
    function UsersEffects(actions$, usersService) {
        var _this = this;
        this.actions$ = actions$;
        this.usersService = usersService;
        this.getUsers$ = this.actions$.pipe(ofType(GET_USERS), switchMap(function () {
            return _this.usersService.users().pipe(map(function (response) {
                var users = response.map(function (user, index) {
                    user.uniqueId = index;
                    return user;
                });
                return new GetUsersSuccessAction(users);
            }), catchError(function (error) { return of(new GetUsersFailureAction(error)); }));
        }));
        this.getCurrentUsers$ = this.actions$.pipe(ofType(GET_CURRENT_USER), switchMap(function () {
            return _this.usersService.getCurrentUser().pipe(map(function (response) {
                var users = response.map(function (user, index) {
                    user.uniqueId = index;
                    return user;
                });
                return new GetCurrentUserSuccessAction(users);
            }), catchError(function (error) { return of(new GetCurrentUserFailureAction(error)); }));
        }));
        this.getUsersStats$ = this.actions$.pipe(ofType(GET_USERS_STATS), switchMap(function () {
            return _this.usersService
                .stats()
                .pipe(map(function (response) { return new GetUsersStatsSuccessAction(response); }), catchError(function (error) { return of(new GetUsersStatsFailureAction(error)); }));
        }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], UsersEffects.prototype, "getUsers$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], UsersEffects.prototype, "getCurrentUsers$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], UsersEffects.prototype, "getUsersStats$", void 0);
    return UsersEffects;
}());
export { UsersEffects };
